import { ApiServiceV2 } from '@sunrise-upc/ajax-lib';
import { v4 as generateUID } from 'uuid';
import { APIResourceConstants } from '../api-constants';
import axios from 'axios';
import { MULTIPLEITEMACCESSORIES } from '../../utils/constants';
import { LineTableBasicPropConfig } from '../LineTableBasicPropConfig';
import { apiResConstants } from '../../components/LineCheckV3/APIResourceConstants';
import { getLocalStorageWithExpiry } from '../../utils/utils';

let getCartSource: any;
let updateCartSource: any;
class multiItemAccessoryUpdateCartService {
  apiServiceInstance: ApiServiceV2;
  constructor() {
    this.apiServiceInstance = ApiServiceV2?.getApiServiceInstance();
  }
   //calling get cart
     getCart = (cartID: string) => {
    if (getCartSource) {
      getCartSource.cancel('Operation cancelled due to new request');
    }
    getCartSource = axios.CancelToken.source();

    // Clone the shared ApiServiceV2 singleton config instead of mutating it directly —
    // getOption() returns the SAME object reference used by every API call in the app,
    // so mutating it in place causes concurrent requests (GET/PUT/other services) to
    // stomp on each other's headers/params/cancelToken.
    const options = { ...this.apiServiceInstance.getOption() };
    /**
     * Code added for B2B cahnnel type change
     */
    let channel = apiResConstants.X_SUN_CHAL;
    // const cartAPIBasicAuth: string = LineTableBasicPropConfig?.getInstance()?.getAuthDetials(apiResConstants.THREE_SCALE_API_KEY);
    const cartBaseEndpoint: string = LineTableBasicPropConfig?.getInstance()?.getCartUrl();
    try {
      const channelB2B = getLocalStorageWithExpiry('isB2BCustomer');
      channel = channelB2B === 'SOHO' ? apiResConstants.X_SUN_B2B_CHAL : apiResConstants.X_SUN_CHAL;
    } catch (error: any) {
      // eslint-disable-next-line no-console
      console.log('erro while setting channle for b2b ==>', error);
    }

    options.headers = {
      ...options.headers,
      'x-correlation-id': generateUID(),
      'x-sunrise-channel': channel
    };
    //  commented for future purpose//  commented for future purpose
    // if (LineTableBasicPropConfig?.getInstance().isDevelopment()) {
    //   options.headers.Authorization = cartAPIBasicAuth;
    // } else {
    //   delete options.headers.Authorization;
    // }
    options.params = {};
    options.cancelToken = getCartSource?.token;

    const URL = cartBaseEndpoint + apiResConstants.GET_CART.replace(':cartId', cartID);
    try {
      return this.apiServiceInstance
        .get(URL, options)
        .then((res) => {
          return res.data;
        })
        .catch((err) => {
          if (!axios.isCancel(err)) {
            return {
              error: err
            };
          }
          return err;
        });
    } catch {
      throw Error('Promise failed');
    }
  };


  //for adding accessory to the cart
  getUpdateCartData = (cartId: any, payload: any, usecase?: string) => {
    if (updateCartSource) {
      updateCartSource.cancel('Operation cancelled due to new request');
    }
    updateCartSource = axios.CancelToken.source();
    // Clone (do not mutate) the shared ApiServiceV2 singleton config — see comment in getCart above.
    const options = { ...this.apiServiceInstance?.getOption() };

    options.headers = {
      ...options?.headers,
      'x-correlation-id': generateUID(),
      'x-sunrise-channel': APIResourceConstants?.X_SUN_CHAL,
    };
    const cartBaseEndpoint: string = LineTableBasicPropConfig?.getInstance()?.getCartUrl();
    options.params = { usecase: usecase || MULTIPLEITEMACCESSORIES };
    options.cancelToken = updateCartSource?.token;
    const URL = cartBaseEndpoint + APIResourceConstants?.UPDATE_CART + `${cartId}`;
    return this.apiServiceInstance
      ?.put(URL, payload, options)
      .then((res: any) => {
        return res?.data;
      })
      .catch((error: any) => {
        // Request was superseded by a newer call (cancelled client-side) — not a real technical failure.
        if (axios.isCancel(error)) {
          return undefined;
        }
        //returning error on 404
        if (error.response) {
          if (error.response.status === 404) {
            return [];
          }
          else {
            throw Error('Promise failed to add/remove recommended accessory Data due to Technical Error!');
          }
        } else {
          throw Error('Promise failed to add/remove recommended accessory Data due to Technical Error!');
        }
      });
  };
}

const multiItemAccessoryUpdateCartServices: multiItemAccessoryUpdateCartService = new multiItemAccessoryUpdateCartService();

export default multiItemAccessoryUpdateCartServices;